import { input, Component, booleanAttribute, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';

import { ProgressSpinner } from '@shared/ui/progress-spinner';

@Component({
  selector: 'app-loading-overlay',
  imports: [ProgressSpinner],
  templateUrl: './loading-overlay.html',
  styleUrl: './loading-overlay.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  host: {
    class: 'app-loading-overlay',
    '[class.app-loading-overlay_loading]': 'loading()',
  },
})
export class LoadingOverlay {
  public readonly loading = input(false, { transform: booleanAttribute });
  public readonly backdrop = input(true, { transform: booleanAttribute });
}
